import { Box, Button, Collapse, Container, Grid, IconButton, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useState } from "react";
import api from "../../hooks/useApi";
import { Form, NavLink, Outlet, useLoaderData } from "react-router-dom";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PageTitle from '../../components/PageTitle';

export async function loader({ request, params }) {
  const tariffs = (await api.get('/api/rates/get/')).data;
  return tariffs;
}

export default function Tariffs() {
  const [period, setPeriod] = useState('1')

  const handlePeriodChange = (ev, period) => {
    setPeriod(period);
  }
  const rates = useLoaderData();
  return (
    <Container maxWidth='xl' sx={{ mt: { md: '50px' } }}>
      <PageTitle title="Тарифи" />
      <Paper sx={{p:2, mb:1}}>
        <Typography variant='h4'>Усі наявні у системі тарифи</Typography>
      </Paper>
      <Grid component={Paper} container sx={{ alignItems: 'center', justifyContent: 'space-between', p: 2, mb: 1 }}>
        <Grid item xs={12} md={4} sx={{ justifyContent: 'start' }}>
          <Button component={NavLink}
            fullWidth
            to='new'
            variant='contained'
            color='primary'>
            <Typography>Додати новий тарифний план</Typography>
          </Button>
        </Grid>
        <Grid item xs={12} md={4} sx={{ justifyContent: 'end' }}>
          <Typography sx={{ textAlign: 'right' }}>
            Показати відсоток скасувань і прибуток за останні:
          </Typography>
          <Form>
            <ToggleButtonGroup
              exclusive
              value={period}
              onChange={handlePeriodChange}
              fullWidth
              color='primary'
              sx={{ textTransform: 'none' }}
            >
              <ToggleButton type='submit' name='period' value='1'>1 місяць</ToggleButton>
              <ToggleButton type='submit' name='period' value='3'>3 місяці</ToggleButton>
              <ToggleButton type='submit' name='period' value='6'>6 місяців</ToggleButton>
              <ToggleButton type='submit' name='period' value='12'>12 місяців</ToggleButton>
            </ToggleButtonGroup>
          </Form>
        </Grid>
      </Grid>
      <Grid container>
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: 'blueButtons.main' }}>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>Назва тарифного плану</TableCell>
                <TableCell>Правила скасування</TableCell>
                <TableCell>Ціна</TableCell>
                <TableCell>Рівень скасувань</TableCell>
                <TableCell>Чистий дохід</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rates.map((el, index) => (
                <ExpandableRowComponent data={el} key={index} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Outlet />
    </Container>
  )
}

const ExpandableRowComponent = ({ data }) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <>
      <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
        <TableCell sx={{ width: '50px' }}>
          <IconButton onClick={() => { setExpanded(prev => !prev) }}>
            {expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>
          <Typography>
            {data.name}
          </Typography>
        </TableCell>
        <TableCell>
          <Typography>
            {data.rates_rules}
          </Typography>
        </TableCell>
        <TableCell>
          <Typography>
            ?????
          </Typography>
        </TableCell>
        <TableCell>
          <Typography>
          </Typography>
        </TableCell>
        <TableCell>
          <Typography>
          </Typography>
        </TableCell>
      </TableRow>
      {expanded && (
        <TableRow>
          <TableCell />
          <TableCell colSpan={5}>
            <Box>
              <Typography>
                Деталі:
              </Typography>
              <Typography sx={{wordBreak:'break-word'}}>
                {JSON.stringify(data)}
              </Typography>
            </Box>
          </TableCell>
        </TableRow>
      )}
    </>
  )
}
